import { Controller } from 'stimulus'
import { DEFAULT_UPLOAD_MAX_SIZE_MB } from '../application/helpers/helpers'

export default class extends Controller {

  connect() {
    // Dropzone init
    Dropzone.autoDiscover = false

    // Without maxFilesize, Dropzone falls back to its own 256 MB default and the
    // "max. N Mb" label promises a limit nothing applies.
    const maxFilesize = parseInt(this.data.get("maxFileSize"), 10) || DEFAULT_UPLOAD_MAX_SIZE_MB

    const myDropzone = new Dropzone(this.element, {
        url: this.element.action,
        maxFilesize,
        dictFileTooBig: I18n.t("workorders.files.max_file_size", { max_size: maxFilesize })
    })

    // A refused file gets no remove link, so its preview would sit in the
    // dropzone for good: flash the reason and drop it, as the uploader does.
    myDropzone.on("error", (file, message) => {
      if (file.accepted) return

      flashAlert(message)
      myDropzone.removeFile(file)
    })
  }
}
